import { TrackJSConfig } from '@com-delta-idp/mnx-utils';
import { TrackJS } from 'trackjs';
import { TRACKJSCONFIG } from '../models/trackjs.constants';

export function installTrackJS() {
  const trackJSConfig = TRACKJSCONFIG;
  return async () => {
    const [env]: TrackJSConfig[] = trackJSConfig
      .filter(({ name }) => name === document.location.hostname)
      .map((config: TrackJSConfig) => {
        delete config.name;
        return config;
      });
    await TrackJS.install(env);
  };
}
